import * as React from "react";
import type { SVGProps } from "react";
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g fill="#050033" clipPath="url(#whatsapp_svg__a)">
      <path d="M14.798 11.492c-.039-.019-1.497-.737-1.756-.83a1 1 0 0 0-.34-.075c-.196 0-.362.098-.49.291-.146.216-.587.732-.723.886-.018.02-.042.045-.057.045-.013 0-.239-.093-.307-.123-1.564-.68-2.751-2.313-2.914-2.589-.023-.04-.024-.057-.024-.057a.5.5 0 0 1 .085-.101c.08-.079.165-.183.249-.283l.117-.14c.121-.14.175-.25.237-.375l.033-.066a.68.68 0 0 0-.02-.64c-.034-.07-.65-1.555-.715-1.711-.158-.377-.366-.552-.655-.552-.027 0 0 0-.112.005-.137.005-.883.104-1.213.311-.35.22-.941.924-.941 2.16 0 1.112.706 2.162 1.009 2.561l.041.06c1.16 1.695 2.608 2.951 4.074 3.537 1.412.564 2.081.63 2.461.63.16 0 .288-.013.4-.024l.072-.007c.488-.043 1.56-.599 1.804-1.276.192-.534.242-1.117.115-1.329-.088-.144-.239-.216-.43-.308" />
      <path d="M10.178 0C4.76 0 .354 4.374.354 9.75c0 1.738.465 3.44 1.347 4.93L.014 19.657a.26.26 0 0 0 .324.33l5.19-1.648a9.9 9.9 0 0 0 4.65 1.159c5.416 0 9.822-4.373 9.822-9.748C20 4.374 15.594 0 10.178 0m0 17.467a7.8 7.8 0 0 1-4.282-1.276.26.26 0 0 0-.221-.03l-2.6.826.84-2.476a.26.26 0 0 0-.037-.237A7.6 7.6 0 0 1 2.397 9.75c0-4.256 3.49-7.72 7.78-7.72s7.78 3.464 7.78 7.72c0 4.255-3.49 7.717-7.78 7.717" />
    </g>
    <defs>
      <clipPath id="whatsapp_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWhatsapp;
